/**
 *  arrays in array - everyIdsInArray
 * @param ids
 * @param arr
 * @return {boolean|*}
 */
const everyIdsInArray = (ids, arr) => ids.every(v => arr.includes(v))

export default everyIdsInArray
